// extracted by mini-css-extract-plugin
export var btn_item = "index-module--btn_item--f7688";
export var btn_item_label = "index-module--btn_item_label--df948";
export var btn_link_wrapper = "index-module--btn_link_wrapper--88b99";
export var close_btn = "index-module--close_btn--7288b";
export var content_wrapper = "index-module--content_wrapper--1c352";
export var desc = "index-module--desc--36fe0";
export var title = "index-module--title--67274";
export var wrapper = "index-module--wrapper--d6d56";